import { from, Observable } from 'rxjs';

export const flushPendo = async (): Promise<void> => {
  await window.pendo?.flushNow?.();
};

export const getFlushPendoObservable = (): Observable<void> => from(flushPendo());
